var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { lessonState } from '../pages/lessons/components/atoms';
import { BookIcon, PlayVideoIcon } from '../components';
import { useNavigate, useParams, useLocation } from 'react-router';
import { IconKeyWords } from '../components/icons';
import MoneyPigIconMenu from '../components/icons/money-pig-menu-icon';
import useUserSesssion from './use-user-session';
import PencilActivity from '../components/icons/pencil-activity';
import { makeRemoteUserSession } from '@/main/factories/usecases/manage-user-session/manage-user-session';
const serviceTrack = makeRemoteUserSession(); // Perhaps it would be better to consider making this a hook parameter.
const useLessons = ({ loadLessons, manageProgressService, Styles, initParams }) => {
    var _a, _b, _c;
    const [state, setState] = useRecoilState(lessonState);
    const { user } = useUserSesssion();
    const navigate = useNavigate();
    let idModule, idLesson, id;
    const { idModule: idModulePath, idLesson: idLessonPath, id: idPath, idVideo, idText, idQuiz, nameActivity } = useParams();
    const { pathname } = useLocation();
    if (!idModulePath) {
        // search in initParams
        if (initParams === null || initParams === void 0 ? void 0 : initParams.idModule)
            idModule = parseInt(initParams === null || initParams === void 0 ? void 0 : initParams.idModule);
        else
            console.error('idModulePath is undefined');
    }
    else {
        idModule = parseInt(idModulePath);
    }
    if (!idLessonPath) {
        // search in initParams
        if (initParams === null || initParams === void 0 ? void 0 : initParams.idLesson)
            idLesson = parseInt(initParams === null || initParams === void 0 ? void 0 : initParams.idLesson);
        else
            console.error('idLessonPath is undefined');
    }
    else {
        idLesson = parseInt(idLessonPath);
    }
    if (!idPath) {
        // search in initParams
        if (initParams === null || initParams === void 0 ? void 0 : initParams.id)
            id = parseInt(initParams === null || initParams === void 0 ? void 0 : initParams.id);
        // else console.error('idPath is undefined');
    }
    else {
        id = parseInt(idPath);
    }
    const getLessonContent = (updateStudentProgress) => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield loadLessons.studentLessonView(idModule, idLesson, id && id !== '' ? parseInt(id) : user.id, updateStudentProgress);
        if (data) {
            setState(prev => (Object.assign(Object.assign({}, prev), { lesson: data, firstLoad: true, reloadItems: !state.reloadItems })));
        }
    });
    useEffect(() => {
        if (idModule && !state.firstLoad)
            getLessonContent('yes');
    }, [idModule]);
    useEffect(() => {
        var _a;
        if ((_a = state.lesson) === null || _a === void 0 ? void 0 : _a.id)
            getMenuItems();
    }, [(_a = state.lesson) === null || _a === void 0 ? void 0 : _a.id, pathname, state.reloadItems]);
    const saveProgress = (progress, listProgress) => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e;
        // validate if the progress is Completed
        if (((_d = progress === null || progress === void 0 ? void 0 : progress.progressStatus) === null || _d === void 0 ? void 0 : _d.description) === 'Completed') {
            return;
        }
        const idProgress = progress === null || progress === void 0 ? void 0 : progress.id;
        // save local progress
        if (idProgress) {
            const newProgressLocalSaving = Object.assign({}, state.progressLocalSaving);
            if (idProgress) {
                newProgressLocalSaving[`progress_${idProgress}`] = { completed: true };
                setState(prev => (Object.assign(Object.assign({}, prev), { progressLocalSaving: newProgressLocalSaving })));
            }
        }
        if (listProgress && Array.isArray(listProgress)) {
            const newProgressLocalSaving = Object.assign({}, state.progressLocalSaving);
            if (idProgress) {
                newProgressLocalSaving[`progress_${(_e = listProgress[0]) === null || _e === void 0 ? void 0 : _e.id}`] = { completed: true };
                setState(prev => (Object.assign(Object.assign({}, prev), { progressLocalSaving: newProgressLocalSaving })));
            }
        }
        // save remote
        setState(prev => (Object.assign(Object.assign({}, prev), { isProgressSaving: true })));
        const data = yield manageProgressService.studentCompleteItem({
            idProgress,
            idsProgress: listProgress && Array.isArray(listProgress) ? listProgress.map(item => item === null || item === void 0 ? void 0 : item.id) : undefined
        });
        if (data) {
            yield getLessonContent('no');
            setState(prev => (Object.assign(Object.assign({}, prev), { isProgressSaving: false, isProgressSaved: true })));
            // hide progress saved afeter 3 seconds
            setTimeout(() => {
                setState(prev => (Object.assign(Object.assign({}, prev), { isProgressSaved: false })));
            }, 3000);
        }
    });
    const getKeywordCompleted = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        try {
            if (((_b = (_a = state === null || state === void 0 ? void 0 : state.lesson) === null || _a === void 0 ? void 0 : _a.lessonsKeyWords) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                ((_f = state === null || state === void 0 ? void 0 : state.progressLocalSaving[`progress_${(_e = (_d = (_c = state === null || state === void 0 ? void 0 : state.lesson) === null || _c === void 0 ? void 0 : _c.lessonsKeyWords[0]) === null || _d === void 0 ? void 0 : _d.progressKeywords) === null || _e === void 0 ? void 0 : _e.id}`]) === null || _f === void 0 ? void 0 : _f.completed))
                return true;
            return (((_h = (_g = state === null || state === void 0 ? void 0 : state.lesson) === null || _g === void 0 ? void 0 : _g.lessonsKeyWords) === null || _h === void 0 ? void 0 : _h.length) > 0 &&
                ((_m = (_l = (_k = (_j = state === null || state === void 0 ? void 0 : state.lesson) === null || _j === void 0 ? void 0 : _j.lessonsKeyWords[0]) === null || _k === void 0 ? void 0 : _k.progressKeywords) === null || _l === void 0 ? void 0 : _l.progressStatus) === null || _m === void 0 ? void 0 : _m.description) === 'Completed');
        }
        catch (error) {
            // console.log(error);
            return false;
        }
    };
    const getActivityName = (activity) => {
        var _a, _b;
        // activity?.frontendConf?.title || activity?.name || 'Unnamed activity'
        if ((_a = activity === null || activity === void 0 ? void 0 : activity.frontendConf) === null || _a === void 0 ? void 0 : _a.title) {
            return `${(_b = activity === null || activity === void 0 ? void 0 : activity.frontendConf) === null || _b === void 0 ? void 0 : _b.title} Activity`;
        }
        return (activity === null || activity === void 0 ? void 0 : activity.name) || 'Unnamed activity';
    };
    const getMenuItems = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const videos = ((_a = state === null || state === void 0 ? void 0 : state.lesson) === null || _a === void 0 ? void 0 : _a.lessonsVideos) || [];
        const texts = ((_b = state === null || state === void 0 ? void 0 : state.lesson) === null || _b === void 0 ? void 0 : _b.lessonsTexts) || [];
        const quizzes = ((_c = state === null || state === void 0 ? void 0 : state.lesson) === null || _c === void 0 ? void 0 : _c.lessonsQuizzes) || [];
        const activities = ((_d = state === null || state === void 0 ? void 0 : state.lesson) === null || _d === void 0 ? void 0 : _d.lessonsActivities) || [];
        const handleOverviewFinish = () => {
            var _a, _b;
            if (videos.length > 0) {
                navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/video/${(_a = videos[0]) === null || _a === void 0 ? void 0 : _a.id}`);
            }
            else if (texts.length > 0) {
                navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/text/${(_b = texts[0]) === null || _b === void 0 ? void 0 : _b.id}`);
            }
            else {
                navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/overview`);
            }
        };
        const videosItems = videos.map(video => {
            var _a, _b, _c, _d;
            return ({
                id: (video === null || video === void 0 ? void 0 : video.id) || 0,
                title: (video === null || video === void 0 ? void 0 : video.name) || 'Unnamed video',
                icon: React.createElement(PlayVideoIcon, { width: "42", height: "42" }),
                status: changeStateByUrl(video === null || video === void 0 ? void 0 : video.id, 'video', Number(idVideo)),
                type: 'video',
                completed: ((_b = (_a = video === null || video === void 0 ? void 0 : video.progressVideos) === null || _a === void 0 ? void 0 : _a.progressStatus) === null || _b === void 0 ? void 0 : _b.description) === 'Completed' ||
                    ((_d = state === null || state === void 0 ? void 0 : state.progressLocalSaving[`progress_${(_c = video === null || video === void 0 ? void 0 : video.progressVideos) === null || _c === void 0 ? void 0 : _c.id}`]) === null || _d === void 0 ? void 0 : _d.completed),
                onFinish: () => __awaiter(void 0, void 0, void 0, function* () { return saveProgress(video === null || video === void 0 ? void 0 : video.progressVideos); }),
                onClick: () => {
                    if (video === null || video === void 0 ? void 0 : video.id) {
                        navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/video/${video === null || video === void 0 ? void 0 : video.id}`);
                    }
                }
            });
        });
        const textItems = texts.map(text => {
            var _a, _b, _c, _d;
            return ({
                id: (text === null || text === void 0 ? void 0 : text.id) || 0,
                title: (text === null || text === void 0 ? void 0 : text.name) || 'Unnamed text',
                icon: React.createElement(BookIcon, { width: "42", height: "42" }),
                status: changeStateByUrl(text === null || text === void 0 ? void 0 : text.id, 'text', Number(idText)),
                type: 'text',
                completed: ((_b = (_a = text === null || text === void 0 ? void 0 : text.progressTexts) === null || _a === void 0 ? void 0 : _a.progressStatus) === null || _b === void 0 ? void 0 : _b.description) === 'Completed' ||
                    ((_d = state === null || state === void 0 ? void 0 : state.progressLocalSaving[`progress_${(_c = text === null || text === void 0 ? void 0 : text.progressTexts) === null || _c === void 0 ? void 0 : _c.id}`]) === null || _d === void 0 ? void 0 : _d.completed),
                onFinish: () => __awaiter(void 0, void 0, void 0, function* () { return saveProgress(text === null || text === void 0 ? void 0 : text.progressTexts); }),
                onClick: () => {
                    if (text === null || text === void 0 ? void 0 : text.id) {
                        navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/text/${text === null || text === void 0 ? void 0 : text.id}`);
                    }
                }
            });
        });
        const quizzesItems = quizzes.map(quizz => {
            var _a, _b, _c, _d;
            return ({
                id: (quizz === null || quizz === void 0 ? void 0 : quizz.id) || 0,
                title: (quizz === null || quizz === void 0 ? void 0 : quizz.name) || 'Unnamed quizz',
                icon: React.createElement("img", { className: Styles.quizImage }),
                status: changeStateByUrl(quizz === null || quizz === void 0 ? void 0 : quizz.id, 'quiz', Number(idQuiz)),
                type: 'quiz',
                completed: ((_b = (_a = quizz === null || quizz === void 0 ? void 0 : quizz.progressQuizzes) === null || _a === void 0 ? void 0 : _a.progressStatus) === null || _b === void 0 ? void 0 : _b.description) === 'Completed' ||
                    ((_d = state === null || state === void 0 ? void 0 : state.progressLocalSaving[`progress_${(_c = quizz === null || quizz === void 0 ? void 0 : quizz.progressQuizzes) === null || _c === void 0 ? void 0 : _c.id}`]) === null || _d === void 0 ? void 0 : _d.completed),
                onFinish: () => __awaiter(void 0, void 0, void 0, function* () { return saveProgress(quizz === null || quizz === void 0 ? void 0 : quizz.progressQuizzes); }),
                onClick: () => {
                    navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/quiz`); // esta ruta es diferente...
                }
            });
        });
        // activities
        const activitiesItems = activities.map(activity => {
            var _a, _b, _c, _d;
            return ({
                id: (activity === null || activity === void 0 ? void 0 : activity.id) || 0,
                title: getActivityName(activity),
                icon: React.createElement(PencilActivity, { width: 32, height: 32 }),
                status: changeStateByUrlActivity(activity === null || activity === void 0 ? void 0 : activity.name, 'activity', nameActivity),
                name: activity === null || activity === void 0 ? void 0 : activity.name,
                type: 'activity',
                completed: ((_b = (_a = activity === null || activity === void 0 ? void 0 : activity.progressActivities) === null || _a === void 0 ? void 0 : _a.progressStatus) === null || _b === void 0 ? void 0 : _b.description) === 'Completed' ||
                    ((_d = state === null || state === void 0 ? void 0 : state.progressLocalSaving[`progress_${(_c = activity === null || activity === void 0 ? void 0 : activity.progressActivities) === null || _c === void 0 ? void 0 : _c.id}`]) === null || _d === void 0 ? void 0 : _d.completed),
                onFinish: () => __awaiter(void 0, void 0, void 0, function* () { return saveProgress(activity === null || activity === void 0 ? void 0 : activity.progressActivities); }),
                onClick: () => {
                    if (activity === null || activity === void 0 ? void 0 : activity.name) {
                        navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/activity/${activity === null || activity === void 0 ? void 0 : activity.name}`);
                    }
                }
            });
        });
        const menuItems = [
            {
                id: 0,
                title: 'Lesson Overview',
                icon: React.createElement(MoneyPigIconMenu, { width: 30, height: 24 }),
                status: pathname.includes('overview') ? 'current' : 'blocked',
                type: 'overview',
                iconBackground: 'white',
                completed: ((_g = (_f = (_e = state === null || state === void 0 ? void 0 : state.lesson) === null || _e === void 0 ? void 0 : _e.overviewProgress) === null || _f === void 0 ? void 0 : _f.progressStatus) === null || _g === void 0 ? void 0 : _g.description) === 'Completed' ||
                    ((_k = state === null || state === void 0 ? void 0 : state.progressLocalSaving[`progress_${(_j = (_h = state === null || state === void 0 ? void 0 : state.lesson) === null || _h === void 0 ? void 0 : _h.overviewProgress) === null || _j === void 0 ? void 0 : _j.id}`]) === null || _k === void 0 ? void 0 : _k.completed),
                onFinish: () => {
                    var _a;
                    saveProgress((_a = state === null || state === void 0 ? void 0 : state.lesson) === null || _a === void 0 ? void 0 : _a.overviewProgress);
                    handleOverviewFinish();
                },
                onClick: () => {
                    navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/overview`);
                }
            },
            ...videosItems,
            ...textItems,
            {
                id: videosItems.length + textItems.length + 1,
                title: 'Keywords',
                icon: React.createElement(IconKeyWords, null),
                status: pathname.includes('keyword') ? 'current' : 'blocked',
                type: 'key-words',
                iconBackground: 'rgba(101, 199, 2, 0.1)',
                completed: getKeywordCompleted(),
                onFinish: () => __awaiter(void 0, void 0, void 0, function* () {
                    var _l, _m;
                    return saveProgress(undefined, (_m = (_l = state === null || state === void 0 ? void 0 : state.lesson) === null || _l === void 0 ? void 0 : _l.lessonsKeyWords) === null || _m === void 0 ? void 0 : _m.map(item => item === null || item === void 0 ? void 0 : item.progressKeywords));
                }),
                onClick: () => {
                    navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/keyword`);
                }
            },
            ...quizzesItems,
            ...activitiesItems
        ];
        setState(prev => (Object.assign(Object.assign({}, prev), { menuItems })));
    };
    const changeStateByUrlActivity = (nameActivity, type, nameActivityPath) => {
        if (nameActivity && nameActivityPath && type) {
            if (nameActivity === nameActivityPath && pathname.includes(type)) {
                return 'current';
            }
            else {
                return 'blocked';
            }
        }
    };
    const changeStateByUrl = (id, type, idActivity) => {
        if (id && idActivity && type) {
            if (id === idActivity && pathname.includes(type)) {
                return 'current';
            }
            else {
                return 'blocked';
            }
        }
    };
    const endLesson = () => __awaiter(void 0, void 0, void 0, function* () {
        const responseTrack = yield serviceTrack.trackLesson({
            idUser: user.id,
            idModule,
            idLesson,
            end: true
        });
        console.log('Lesson completed', responseTrack);
    });
    const firstLoading = !state.firstLoad && !state.lesson;
    const allItemsCompleted = ((_b = state === null || state === void 0 ? void 0 : state.menuItems) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((_c = state === null || state === void 0 ? void 0 : state.menuItems) === null || _c === void 0 ? void 0 : _c.every(item => item === null || item === void 0 ? void 0 : item.completed));
    useEffect(() => {
        if (allItemsCompleted && state.lessonCompleted === false && state.isLoading === false && state.firstLoad) {
            setState(prev => (Object.assign(Object.assign({}, prev), { lessonCompleted: true })));
            endLesson();
        }
    }, [allItemsCompleted, state.lessonCompleted, state.isLoading, state.firstLoad]);
    return {
        firstLoading,
        menuItemsState: (state === null || state === void 0 ? void 0 : state.menuItems) || [],
        saveProgress
    };
};
export default useLessons;
